export class MassConverter {
    public convert(amount: number, from: MassUnit, to: MassUnit) {
        const fromFactor = this.unitInGram(from)
        const toFactor = this.unitInGram(to)
        return amount * fromFactor / toFactor
    }

    public convertMass(from: Mass, to: MassUnit) {
        const fromFactor = this.unitInGram(from.unit)
        const toFactor = this.unitInGram(to)
        return from.value * fromFactor / toFactor
    }

    private unitInGram (unit: MassUnit) {
        switch (unit) {
            case "kg": return 1000
            case "g": return 1
            case "pinch": return 0.355625
            case "dag": return 10
            default: return 1
        }
    }
}
